export const navLinks = [
  { path: "/", label: "Home" },
  { path: "/about", label: "About" },
  { path: "/services", label: "Services" },
  { path: "/projects", label: "Projects" },
  { path: "/gallery", label: "Gallery" },
  { path: "/careers", label: "Careers" },
  { path: "/contact", label: "Contact" },
];

export const company = {
  name: "SBRGREEN CONSTRUCTION PRIVATE LIMITED",
  shortName: "SBRGREEN",
  tagline: "Building lasting structures. Growing greener futures.",
  phone: "+91 98765 43210",
  email: "info@sbrgreen.com",
  address: "Plot 42, Green Tech Park, Sector 18, Gurugram, Haryana 122001",
  hours: "Mon – Sat: 9:00 AM – 6:00 PM",
};
